enum NativeName {
  English = 'English',
  Spanish = 'Espa\u00F1ol',
  French = 'Fran\u00E7ais',
  German = 'Deutsch',
  Italian = 'Italiano',
  BrazilPortuguese = 'Portugu\u00EAs (Brasil)',
  Korean = '\uD55C\uAD6D\uC5B4',
  SimplifiedChinese = '\u4E2D\u6587(\u7B80\u4F53)',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SimplifiedChineseJV = '\u4E2D\u6587(\u7B80\u4F53)',
  TraditionalChinese = '\u4E2D\u6587(\u7E41\u9AD4)',
  Japanese = '\u65E5\u672C\u8A9E',
  Russian = '\u0420\u0443\u0441\u0441\u043A\u0438\u0439',
  Indonesian = 'Bahasa Indonesia',
  Polish = 'Polski',
  Vietnamese = 'Ti\u1EBFng Vi\u1EC7t',
  Turkish = 'T\u00FCrk\u00E7e',
  Arabic = '\u0627\u0644\u0639\u0631\u0628\u064A\u0629',
  Thai = '\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22',
}

export default NativeName;
